import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({ baseURL: API });

// SECURITY NOTE (accepted risk): Admin JWT is stored in localStorage.
// This is XSS-vulnerable in principle, but this dashboard is admin-only over
// HTTPS with no user-generated HTML rendered anywhere in the admin surface,
// so the practical XSS attack surface is negligible. Revisit if any admin
// page ever starts rendering untrusted markup / user-uploaded SVGs.
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("smq_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function setToken(t) {
  if (t) localStorage.setItem("smq_token", t);
  else localStorage.removeItem("smq_token");
}

export function getToken() {
  return localStorage.getItem("smq_token");
}
